<script>
    import VerifyEmail from "../../Pages/Verify/VerifyEmail.svelte";
</script>

<div class="flex flex-col flex-1 w-full align-left">
    <VerifyEmail />
</div>
